module.exports = __webpack_public_path__ + "img/Date.8e83eac3.svg";